export function isOwnedBuilderDraft({
    authorId,
    currentUserId,
    isPublished,
}: {
    authorId?: string | null;
    currentUserId?: string | null;
    isPublished?: boolean | null;
}): boolean {
    return Boolean(currentUserId && authorId === currentUserId && isPublished !== true);
}

export function compareOwnedDraftFirst<T>(
    a: T,
    b: T,
    get: (item: T) => { authorId?: string | null; isPublished?: boolean | null; label: string },
    currentUserId?: string | null
): number {
    const ownedA = isOwnedBuilderDraft({ ...get(a), currentUserId });
    const ownedB = isOwnedBuilderDraft({ ...get(b), currentUserId });
    if (ownedA !== ownedB) return ownedA ? -1 : 1;
    return get(a).label.localeCompare(get(b).label, undefined, { sensitivity: "base" });
}
